import type { ProLayoutProps } from '@ant-design/pro-components';

/**
 * @name
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  navTheme: 'light',
  // 主题色
  colorPrimary: '#2cbc63',
  layout: 'mix',
  contentWidth: 'Fluid',
  fixedHeader: false,
  fixSiderbar: true,
  colorWeak: false,
  title: 'CABIC',
  pwa: true,
  logo: '/logo.png',
  iconfontUrl: '',
  token: {
    // 通过 token 修改样式
    colorPrimary: '#2cbc63',
  },
};

export default Settings;
